import { ReactElement } from 'react';
import { IRoute } from 'interfaces/routesInt';
import urls from '../urls';
import ManageRoutes from 'routes/manageRoute';

const publicPageElement: ReactElement = <ManageRoutes />;

const publicRoutes: IRoute[] = [
  {
    path: urls.landingPage,
    element: publicPageElement,
    isProtected: false,
    key: urls.landingPage,
    requireLocation: false,
  },
  {
    path: urls.login,
    element: publicPageElement,
    isProtected: false,
    key: urls.login,
    requireLocation: false,
  },
  {
    path: urls.login,
    element: publicPageElement,
    isProtected: false,
    key: urls.login,
    requireLocation: false,
  },
  {
    path: urls.register,
    element: publicPageElement,
    isProtected: false,
    key: urls.register,
    requireLocation: false,
  },
  {
    path: urls.accountOpening,
    element: publicPageElement,
    isProtected: false,
    key: urls.accountOpening,
    requireLocation: false,
  },
  {
    path: urls.remindUsername,
    element: publicPageElement,
    isProtected: false,
    key: urls.remindUsername,
    requireLocation: false,
  },
  {
    path: urls.forgotPassword,
    element: publicPageElement,
    isProtected: false,
    key: urls.forgotPassword,
    requireLocation: false,
  },
];

export default publicRoutes;
